import { restApi } from './restApiSlice';

export const environmentApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getEnvironment: builder.query({
      query: () => ({ url: '/v3/environment', method: 'GET' }),
      providesTags: ['Environment'],
    }),
    setQueryParamsSettings: builder.mutation({
      query: (body) => ({
        url: '/v3/environment',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Environment', 'EnvironmentHistory'],
    }),
  }),
});

export const { useSetQueryParamsSettingsMutation, useGetEnvironmentQuery } = environmentApi;
